// bao migrate skip
import TabPage from "./../factories/tab-page";
import "./../bindings/bao-tabs";
import "./../bindings/bao-number-box";
import "./../bindings/bao-date-time-box";
import "./../services/bao-router";
import BaseViewModel from "./../factories/base-view-model2";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialog from "./../factories/bao-dialog";
import baoRouter from "./../services/bao-router";
class SoftwareLicenseUpgrade extends BaseViewModel {
    SoftwareLicenceUpgradeId: KnockoutObservable<string> = ko.observable<string>();
    SoftwareLicenceId: KnockoutObservable<string> = ko.observable<string>();
    SoftwareLicenceUpgradeFromId: KnockoutObservable<string> = ko.observable<string>();
    LicenceKey: KnockoutObservable<string> = ko.observable<string>();
    CountOfLicences: KnockoutObservable<number> = ko.observable<number>();
    OrderDateJS: KnockoutObservable<any> = ko.observable();
    OrderNumber: KnockoutObservable<number> = ko.observable<number>();
    SearcherSoftwareLicenseUpgradeFrom: Bindings.baoSearcher = {
        ObjectId: this.SoftwareLicenceUpgradeFromId,
        ObjectValue: 'SoftwareName',
        SearchType: 'SoftwareLicence',
        AutoSearch: true,
        AutoComplete: true,
        AutoCompleteOpts: { preselect: false },
        Enabled: true,
        CustomFilter: {}
    };
    DateTimeBoxOrderDate: Bindings.baoDateTimeBox = {
        value: this.OrderDateJS,
        culture: Bao.Session.Language.Symbol()
    };
    NumberBoxCountOfLicences: Bindings.baoNumberBox = {
        value: this.CountOfLicences,
        decimalDigits: 0,
        thousandSeperator: false,
        culture: Bao.Session.Language.Symbol()
    };
    constructor(tabPage: TabPage) {
        super(tabPage);
    }
    CompleteCheck(): JQueryPromise<boolean> | boolean {
        var completed: boolean;
        completed = true;
        if (!this.SoftwareLicenceUpgradeFromId() || !this.CountOfLicences()) {
            completed = false;
        }
        if (!completed) {
            var baoDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return completed;
    }
    InitUrl(): string {
        return "SoftwareLicenseUpgrade/Init";
    }
    loaded() {
        this.SoftwareLicenceUpgradeFromId.subscribe((value) => {
            if (value) {
                Bao.post("License/Get", JSON.stringify({
                    id: value
                }), (model) => {
                    if (model) {
                        this.LicenceKey(model.LicenceKey);
                        this.OrderDateJS(model.OrderDateJS);
                        this.OrderNumber(model.OrderNumber);
                    }
                });
            }
        });
        return super.loaded();
    }
    init(): JQueryPromise<void> {
        var softwareLicenceId = baoRouter.getRouteValue("softwarelicenceid", this.TabPage);
        return super.init().then(() => {
            if (softwareLicenceId) {
                this.SoftwareLicenceId(softwareLicenceId);
            }
        });
    }
}
export default SoftwareLicenseUpgrade;